import React from "react";

const MultiSelectCellRenderer = (params) => {
  const { colDef, value } = params;
  if (colDef?.options?.length > 0 && Array.isArray(value)) {
    const mappedValues = value.map(
      (item) =>
        colDef.options.find((lt) => lt._id === item)?.option_name || "Unknown"
    );
    return <span>{mappedValues.join(", ")}</span>;
  } else {
    if (colDef?.options) {
      const mappedValues =
        colDef.options.find((lt) => lt._id === value)?.option_name || "";

      return <span>{mappedValues}</span>;
    }
  }
  return <span></span>;
};

export default MultiSelectCellRenderer;
